var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAccountant(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFDC00"
    },
    cx: 256,
    cy: 256,
    r: 256
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC000"
    },
    d: "M511.937,261.007L388.558,137.629l-21.261,32.351L295.78,98.463l-125.87,8.288l-24.546,82.424 L67,228.038l98.169,98.169l-83.256,40.808L225.028,510.13C235.182,511.355,245.515,512,256,512 C395.711,512,509.267,400.079,511.937,261.007z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#754C24"
    },
    d: "M295.779,185.129h-136V98.462h136V185.129z M176.779,168.129h102v-52.666h-102L176.779,168.129 L176.779,168.129z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#603813"
    },
    points: "295.779,98.462 229.606,98.462 229.606,115.462 278.779,115.462 278.779,168.129  229.606,168.129 229.606,185.129 295.779,185.129 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.913,
    y: 152.54,
    style: {
      fill: "#754C24"
    },
    width: 291.73,
    height: 214.47
  }), /*#__PURE__*/React.createElement("rect", {
    x: 229.61,
    y: 152.54,
    style: {
      fill: "#603813"
    },
    width: 144.04,
    height: 214.47
  }), /*#__PURE__*/React.createElement("rect", {
    x: 67,
    y: 137.63,
    style: {
      fill: "#8C6239"
    },
    width: 321.56,
    height: 90.41
  }), /*#__PURE__*/React.createElement("rect", {
    x: 229.61,
    y: 137.63,
    style: {
      fill: "#754C24"
    },
    width: 158.95,
    height: 90.41
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210.22,
    y: 205.24,
    style: {
      fill: "#FBB03B"
    },
    width: 35.11,
    height: 50.757
  }), /*#__PURE__*/React.createElement("rect", {
    x: 229.61,
    y: 205.24,
    style: {
      fill: "#D89032"
    },
    width: 15.727,
    height: 50.757
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260.91,
    y: 214.35,
    style: {
      fill: "#333333"
    },
    width: 164.35,
    height: 199.63
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340.8,
    y: 214.35,
    style: {
      fill: "#1A1A1A"
    },
    width: 84.46,
    height: 199.63
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.27,
    y: 226.07,
    style: {
      fill: "#B9EAFF"
    },
    width: 141.63,
    height: 42.956
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340.8,
    y: 226.07,
    style: {
      fill: "#35CCFF"
    },
    width: 73.1,
    height: 42.956
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#808080"
    },
    cx: 286.45,
    cy: 299.86,
    r: 12.471
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#808080"
    },
    cx: 322.87,
    cy: 299.86,
    r: 12.471
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#666666"
    },
    cx: 359.29,
    cy: 299.86,
    r: 12.471
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#808080"
    },
    cx: 286.45,
    cy: 341.11,
    r: 12.471
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#808080"
    },
    cx: 322.87,
    cy: 341.11,
    r: 12.471
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#666666"
    },
    cx: 359.29,
    cy: 341.11,
    r: 12.471
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#808080"
    },
    cx: 286.45,
    cy: 382.35,
    r: 12.471
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#808080"
    },
    cx: 322.87,
    cy: 382.35,
    r: 12.471
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#666666"
    },
    cx: 359.29,
    cy: 382.35,
    r: 12.471
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FF6838"
    },
    cx: 398.18,
    cy: 299.86,
    r: 12.471
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FF6838"
    },
    cx: 398.18,
    cy: 341.11,
    r: 12.471
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FF6838"
    },
    cx: 398.18,
    cy: 382.35,
    r: 12.471
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountant);
export default __webpack_public_path__ + "static/media/accountant.34a5e29ec3263d4e16ab875130fad4ab.svg";
export { ForwardRef as ReactComponent };